import { Store } from '@ngxs/store';
import { TranslationId } from '@platform-frontend/util';
import { Observable } from 'rxjs';

export interface AccountCustomizedTextsToContinueInstructions {
  default: TranslationId;
  signIn: TranslationId;
}

export interface AccountCustomizedTexts {
  oAuth: {
    termsAndPrivacyPolicy: TranslationId;
  };
  signIn: {
    title: (store: Store) => TranslationId;
  };
  verifyEmail: {
    toContinueInstructions: AccountCustomizedTextsToContinueInstructions;
  };
  registrationComplete: {
    text: (store: Store) => Observable<TranslationId>;
  };
}
